export default __webpack_public_path__ + "static/media/location_city.77ed52fc.svg";